module.exports = __webpack_public_path__ + "img/osi-logo.f62887f1.svg";